import { ReactNode, useMemo } from 'react';
import { ServicesContext, buildServices } from '../contexts/ServicesContext';
import { useAuth, useAuthActions } from '../contexts/AuthContext';

/**
 * ServicesProvider — constrói os serviços de API ligados ao token da sessão
 * atual (AuthContext) e os disponibiliza via ServicesContext. O ApiClient anexa
 * `Authorization: Bearer <token>` a cada chamada e, em 401, dispara o logout
 * (RN-M1-002) — o redirecionamento ao /login é feito pelo ProtectedRoute quando
 * a sessão fica anônima.
 */
export function ServicesProvider({
  apiBaseUrl,
  children,
}: {
  apiBaseUrl: string;
  children: ReactNode;
}): JSX.Element {
  const auth = useAuth();
  const { logout } = useAuthActions();
  const services = useMemo(
    () => buildServices(apiBaseUrl, () => auth.token, logout),
    [apiBaseUrl, auth.token, logout],
  );
  return <ServicesContext.Provider value={services}>{children}</ServicesContext.Provider>;
}
